import store from "../redux/store";
import axios from "axios";

const API_BASE_URL = "http://localhost:8080";

 
// Helper function to handle API calls
const apiCall = async (url, options, requiresToken = true) => {
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    if (requiresToken) {
      const token = store.getState().auth.token;
      if (!token) {
        throw new Error("No token found. User not authenticated.");
      }
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(url, { headers, ...options });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`API Error (${options.method} ${url}):`, error);
    throw error;
  }
};

// Function to update Employee details
export const updateEmployeeDetails = async (email, updatedData) => {
  return apiCall(`${API_BASE_URL}/users/${email}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token")}`,  // Ensure the token is stored in localStorage
    },
    body: JSON.stringify(updatedData),
  });
};

//Function to view Employee details
export const fetchEmployeeDetails= async (email) => {
  return apiCall(`${API_BASE_URL}/users/view/${email}`, { method: "GET" });
};

//Function to view Employee details by admin
export const fetchEmployeeById= async (uid) => {
  return apiCall(`${API_BASE_URL}/users/searchview/${uid}`, { method: "GET" });
};
 
// Function to fetch data for Dropdown component
export const fetchDataForDropdown = async (endpoint) => {
    console.log("fetchDataForDropdown endpoint:", endpoint);
    return apiCall(`${API_BASE_URL}/${endpoint}`, { // endpoint is locations,status
      method: "GET",
    });
  };

// Function to load paginated employees from the cache.
export const fetchEmployees = async (page, size) => {
  return apiCall(`${API_BASE_URL}/search?page=${page}&size=${size}`, {
    method: "GET",
  });
};
 
// Function to search employees
export const searchEmployees = async (queryParams) => {
  return apiCall(`${API_BASE_URL}/search/employees`, {
    method: "POST",
    body: JSON.stringify(queryParams),
  });
};
 
// Function to export all employees
export const exportAllEmployees = async () => {
  return apiCall(`${API_BASE_URL}/search/exportAll`, { method: "GET" });
};
 
// Function to load paginated employees by competences.
export const fetchEmployeesByCompetences = async (page, size) => {
  return apiCall(`${API_BASE_URL}/search/competences?page=${page}&size=${size}`, {
    method: "GET",
  });
};



// Function to search employees by competences.
export const searchEmployeesByCompetences = async (queryParams) => {
  return apiCall(`${API_BASE_URL}/search/byCompetences`, {
    method: "POST",
    body: JSON.stringify(queryParams),
  });
};

// Function to export all employees by competences.
export const exportAllEmployeesByCompetences = async () => {
  return apiCall(`${API_BASE_URL}/search/exportAllCompetences`, { method: "GET" });
};

// Function to create a new user account activity
export const createUserAccountActivity = async (uid, activityData) => {
  return apiCall(`${API_BASE_URL}/userAccountActivities/${uid}`, {
    method: "POST",
    body: JSON.stringify(activityData),
  });
};
//Function to fetch Training Portal
export const fetchTrainingPortal = async () => {
  return apiCall(`${API_BASE_URL}/api/training`, {
    method: "GET",
  });
};


export const fetchTrainingPortalById = async (id) => {
   return apiCall(`${API_BASE_URL}/api/training/${id}`, {
    method: "GET",
  });
  };
  
// Function to fetch user account activities
export const fetchUserAccountActivities = async (uid) => {
  return apiCall(`${API_BASE_URL}/userAccountActivities/${uid}`, {
    method: "GET",
  });
};

// Function to edit a user account activity
export const editUserAccountActivity = async (activityId, activityData) => {
  return apiCall(`${API_BASE_URL}/userAccountActivities/${activityId}`, {
    method: "PUT",
    body: JSON.stringify(activityData),
  });
};

// Function to delete a user account activity
export const deleteUserAccountActivity = async (uid, activityId) => {
  return apiCall(`${API_BASE_URL}/userAccountActivities/${uid}/${activityId}`, {
    method: "DELETE",
  });
};

// Function to search Onboarding Users
export const getOnboardingUser = async (trimmedInput) => {
  return apiCall(`${API_BASE_URL}/api/search/${trimmedInput}`, { method: "GET" });
};
 
export const notifyAllStatus = async (userId) => {
  console.log("Sending status to mail");
  return apiDocCall(`${API_BASE_URL}/api/onboarding/send-status/${userId}`, { method: "POST" });
};
 
// Acknowledge functionality for Skill Repository
export const acknowledgeSkillRepo = async (queryParams, method) => {
 //alert(queryParams.uid);
 const apiUrl = `${API_BASE_URL}/api/skill/${method === "POST" ? "add" : `delete/${queryParams.userId}`}`;
  //console.log(method);
  //console.log(apiUrl);
  return apiDocCall(apiUrl, {
      method: method,
      body: method === "POST" ? JSON.stringify(queryParams) : null,
  });
};
export const getSkillRepoStatus = async (userId) => {
  console.log("getting status");
  return apiDocCall(`${API_BASE_URL}/api/skill/status/${userId}`, { method: "GET" });
};

export const getVDIRepoStatus = async (userId) => {
  console.log("getting status");
  return apiDocCall(`${API_BASE_URL}/api/vdi/status/${userId}`, { method: "GET" });
};
 
export const acknowledgeVDICompliance = async (queryParams, method) => {
 
  const apiUrl = `${API_BASE_URL}/api/vdi/${method === "POST" ? "add" : `delete/${queryParams.userId}`}`;
   //console.log(method);
   //console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: method,
       body: method === "POST" ? JSON.stringify(queryParams) : null,
   });
 };
 /*
 export const updateBGVForm = async (queryParams) => {
  const apiUrl = `${API_BASE_URL}/api/bgv/upload/BGV_FORM`;
 
  const formData = new FormData();
  Object.keys(queryParams).forEach(key => {
    formData.append(key, queryParams[key]);
  });
 
console.log(formData)
return apiDocCall(apiUrl, {
  method: "POST",
  body: formData, // Pass FormData directly
});
};

*/
  export const updateBGVForm = async (queryParams) => {
    //const apiUrl = `${API_BASE_URL}/api/bgv/upload/BGV_FORM`;
    const apiUrl = `${API_BASE_URL}/api/bgv`;
   console.log(queryParams)
  return apiDocCall(apiUrl, {
    method: "PUT",
    body: queryParams, // Pass FormData directly
  });
};


export const getBGVStatus = async (userId) => {
  console.log("getting status");
  return apiDocCall(`${API_BASE_URL}/api/bgv/${userId}`, { method: "GET" });
};

export const getAuthrizationStatus = async (userId) => {
  console.log("getting status");
  return apiDocCall(`${API_BASE_URL}/api/authorization/${userId}`, { method: "GET" });
};

export const fetchDrugTestData = async (userId) => {
  console.log("getting status");
  return apiDocCall(`${API_BASE_URL}/api/drugtest/${userId}`, { method: "GET" });
};


export const deleteBGVForm = async (queryParams) => {
  const apiUrl = `${API_BASE_URL}/api/bgv/${queryParams}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
      });
 };
 

export const updateAuthorizationForm = async (formData) => {
  const apiUrl = `${API_BASE_URL}/api/authorization`;
 console.log(formData)
  return apiDocCall(apiUrl, {
    method: "PUT",
    body: formData, // Pass FormData directly
  });
};
export const deleteAuthorizationForm = async (queryParams) => {

  const apiUrl = `${API_BASE_URL}/api/authorization/${queryParams}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
      });
 };

 export const addFileDrugTest = async (formData, userId) => {
  const apiUrl = `${API_BASE_URL}/api/drugtest/upload/${userId}`;
 
  console.log(formData)
  return apiDocCall(apiUrl, {
    method: "PUT",
    body: formData, // Pass FormData directly
  });
};
 
export const deleteFileDrugTest = async (queryParams) => {
 
  const apiUrl = `${API_BASE_URL}/api/drugtest/deleteDoc/${queryParams}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
       body: JSON.stringify(queryParams),
      });
 };
 
export const addDrugTestDate = async (queryParams) => {
  
  return apiDocCall(`${API_BASE_URL}/api/drugtest`, {
    method: "PUT",
    body: JSON.stringify(queryParams),
  });
};
 
export const deleteDrugTestDate = async (queryParams) => {
 
  const apiUrl = `${API_BASE_URL}/api/drugtest/delete/${queryParams}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
      });
 };
 
 export const saveDrugTestComment = async (queryParams,userId) => {
 
  const apiUrl = `${API_BASE_URL}/api/drugtest/comment/${userId}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
       body: JSON.stringify(queryParams),
      });
 };
// To save VDI Compliance 
 export const saveVDICompliance = async (userId) => {
  
  const apiUrl = `${API_BASE_URL}/api/vdi/${userId}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
      });
 };

 // To retrive VDI Compliance date for a user
 export const getVDIComplianceDate = async (userId) => {
  
  const apiUrl = `${API_BASE_URL}/api/vdi/getDate/${userId}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "GET",
      });
 };


 export const addTraining = async (transformedData,token) => {
  
  const apiUrl = `${API_BASE_URL}/api/training`;
 
  return apiDocCall(apiUrl, {
       method: "POST",
       body: JSON.stringify(transformedData),
       headers: {
        'Authorization': `Bearer ${token}`,  
        'Content-Type': 'application/json'
      }
      })
};

export const getTraining = async (token) =>{

const apiUrl = `${API_BASE_URL}/api/training`;

    return apiDocCall(apiUrl,{
        method: "GET",
       headers:{
        'Authorization' :`Bearer ${token}`
       }
      })
};



 export const updateTraining = async (dataId,transformedData,token) => {
  
  const apiUrl = `${API_BASE_URL}/api/training/${dataId}`;
 
  return apiDocCall(apiUrl, {
       method: "PUT",
       body: JSON.stringify(transformedData),
       headers: {
        'Authorization': `Bearer ${token}`,  // Replace `token` with the actual token you want to pass
        'Content-Type': 'application/json'
      }
      })
};


 export const deleteTraining = async (recordId,token) => {
  
  const apiUrl = `${API_BASE_URL}/api/training/${recordId}`;
 
  return apiDocCall(apiUrl, {
       method: "DELETE",
       headers: {
        'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
      }
      })
};

 // To send the Users information to Onboarding mail service
export const onboardingUsersInformationSendingMail = async (formData) => {
  
  const apiUrl = `${API_BASE_URL}/api/onboarding`;
   console.log("Mail information : " + formData);
   return apiDocCall(apiUrl, {
       method: "PUT",
       body: JSON.stringify(formData),
      });
 };

 export const AddActivity = async (formData) => {
  
  const apiUrl = `${API_BASE_URL}/api/accountActivities`;
   console.log(formData);
   return apiDocCall(apiUrl, {
       method: "POST",
       body: JSON.stringify(formData),
      });
 };

 export const editActivity = async (queryParams,activityId) => {
 
  const apiUrl = `${API_BASE_URL}/api/accountActivities/${activityId}`;
   console.log(apiUrl);
   return apiDocCall(apiUrl, {
       method: "PUT",
       body: JSON.stringify(queryParams),
      });
 };

 export const fetchAllActivities = async (page,size) => {
  const apiUrl = `${API_BASE_URL}/api/accountActivities?page=${page}&size=${size}`;
  return apiDocCall(apiUrl, {
    method: "GET",
  });
};
 // Helper function to handle API calls when the return type is Text not the Json
const apiDocCall = async (url, options, requiresToken = true) => {
  try {
    let headers = {};
    // Check if the body is an instance of FormData
    if (!(options.body instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }
    if (requiresToken) {
      const token = store.getState().auth.token;
      if (!token) {
        throw new Error("No token found. User not authenticated.");
      }
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(url, { headers, ...options });

    // Check the Content-Type of the response
    const contentType = response.headers.get("Content-Type");

    // Parse response based on Content-Type
    let responseData;
    if (contentType && contentType.includes("application/json")) {
      responseData = await response.json();
    } else {
      responseData = await response.text();
    }
    console.log(responseData);
    return { ok: response.ok, status: response.status, data: responseData };
  } catch (error) {
    console.error(`API Error (${options.method} ${url}):`, error);
    throw error;
  }
};

//Get data from json
export const fetchDataForFilterDropdown = async (endpoint) => {
  console.log("Fetching data for dropdown from JSON file:", endpoint);
  
  try {
    // Dynamically fetch the JSON file based on the endpoint name
    const response = await fetch(`/data/search/${endpoint}.json`);
    
    if (!response.ok) throw new Error(`Failed to load ${endpoint}.json`);
    
    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("Error fetching JSON file:", error);
    return [];
  }
};

export const AddJob = async (formData) => {
  
  const apiUrl = `${API_BASE_URL}/api/user/jobs/create`;
   console.log(formData);
   return apiDocCall(apiUrl, {
       method: "POST",
       body: JSON.stringify(formData),
      });
 };

 // Function to search employees
export const userComplianceAnalytics = async () => {
  return apiCall(`${API_BASE_URL}/analytics`, {
    method: "GET",
  });
};
export const convertTo24HourFormat = (time12h) => {
  const [time, modifier] = time12h.split(' ');
  let [hours, minutes] = time.split(':');

  if (modifier === 'AM' && hours === '12') {
    hours = '00'; // Midnight case
  } else if (modifier === 'PM' && hours !== '12') {
    hours = (parseInt(hours) + 12).toString(); // Convert PM hours
  }

  return `${hours.padStart(2, '0')}:${minutes}`;
};
export  const formatTimeArray = (timeArray) => {
  if (Array.isArray(timeArray) && timeArray.length === 2) {
    const [hours, minutes] = timeArray;
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
  }
  return null; // Return null if the input is not a valid time array
};

//UserAttendedTraining page services


const token = store.getState().auth.token;

const headers = {
  Authorization: `Bearer ${token}`,
};

export const getUserTrainings = async (userId) => {
  return axios.get(`${API_BASE_URL}/userAttendedTrainings/${userId}`, { headers });
};

export const addUserTraining = async (userId, trainingData) => {
  return axios.post(`${API_BASE_URL}/userAttendedTrainings/${userId}`, trainingData, { headers });
};

export const deleteUserTraining = async (userId, trainingId) => {
  return axios.delete(`${API_BASE_URL}/userAttendedTrainings/${userId}/${trainingId}`, { headers });
};

export const getAvailableTrainings = async () => {
  return axios.get(`${API_BASE_URL}/api/training`, { headers });
};
